import moment from 'moment'

import * as BBApi from '.'
const rootUrl = BBApi.host + '/notifications'

export type Notification = any
export type NotificationCreate = any
export type NotificationUpdate = any
export type NotificationQuery = any

export const query = async (query: NotificationQuery) => {
	const url = new URL(rootUrl)

	const [dateFrom = null, dateTo = null] = query?.date ?? []
	if (dateFrom !== null) url.searchParams.append('dateFrom', dateFrom.format('YYYY-MM-DD'))
	if (dateTo !== null) url.searchParams.append('dateTo', dateTo.format('YYYY-MM-DD'))
	if (query.status && query.status !== 'all') url.searchParams.append('status', query.status)
	if (query.name && query.name !== '') url.searchParams.append('name', '%' + query.name + '%')

	const response = await BBApi.get(url.href)

	if (response.ok === false) {
		throw new Error('Query error occurred')
	}

	const notifications = await response.json()
	return notifications as Notification[]
}

export const get = async (notificationId: number | string) => {
	const response = await BBApi.get(rootUrl + '/' + notificationId)

	if (response.ok === false) {
		throw new Error('Notification not found')
	}

	const notification = await response.json()
	notification.scheduled = moment(notification.scheduled)
	return notification as Notification
}

export const create = async (notification: NotificationCreate) => {
	const response = await BBApi.post(rootUrl, notification)

	if (response.ok === false) {
		throw new Error('Notification not created')
	}

	const notificationId = await response.text()
	return Number(notificationId)
}

export const update = async (notificationId: number | string, notification: NotificationUpdate) => {
	const response = await BBApi.patch(rootUrl + '/' + notificationId, notification)

	if (response.ok === false) {
		throw new Error('Notification not updated')
	}
}

export const remove = async (notificationId: number | string) => {
	const response = await BBApi.del(rootUrl + '/' + notificationId)

	if (response.ok === false) {
		throw new Error('Notification not deleted')
	}
}

export const preview = async (notificationId: number | string) => {
	const response = await BBApi.post(rootUrl + '/' + notificationId, {})

	if (response.ok === false) {
		throw new Error('Notification error')
	}
}

export const getExposureCount = async (notification: any) => {
	const response = await BBApi.post(rootUrl + '/exposure-count', notification)

	if (response.ok === false) {
		throw new Error('Exposure count error')
	}

	const exposureCount = await response.text()
	return Number(exposureCount)
}

export const getUser = async (search: string) => {
	const url = new URL(rootUrl + '/user')
	url.searchParams.append('search', search)

	const response = await BBApi.get(url.href)
	if (response.ok === false) throw new Error('Query error occurred')

	const user = await response.json()
	return user
}

export const copy = async (notificationId: number) => {
	const response = await BBApi.post(`${rootUrl}/${notificationId}/copy`, {})
	if (response.ok === false) throw new Error()
}
